import { useIsMobile } from "@hooks/use-mobile";
import CitySelectionModalMobile from "./CitySelectionModalMobile";
import CitySelectionModalDesktop from "./CitySelectionModalDesktop";
import { CitySelectionModalProps } from "./City.types";

export default function CitySelectionModal(props: CitySelectionModalProps) {
  const isMobile = useIsMobile();
  
  return isMobile ? (
    <CitySelectionModalMobile {...props} />
  ) : (
    <CitySelectionModalDesktop {...props} />
  );
}
